import React from 'react';
import _ from 'lodash';
import i18n from 'i18next';
import { withTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import ModalDialog from '../ui/modal-dialog';
import { setOpenDialog, setDialogContent } from '../../redux/traffic-dashboard';
var t = i18n.getFixedT(null, 'traffic-dashboard');
var gt = i18n.getFixedT(null, 'app');
var TrafficEventDialog = /*#__PURE__*/React.memo(function (props) {
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      _useSelector$trafficD = _useSelector.trafficDashboard,
      openDialog = _useSelector$trafficD.openDialog,
      dialogContent = _useSelector$trafficD.dialogContent;

  var dispatch = useDispatch();

  var handleCloseDialog = function handleCloseDialog() {
    dispatch(setOpenDialog(false));
    dispatch(setDialogContent({}));
  };

  if (!openDialog) return null;
  var actions = {};

  _.set(actions, 'cancel', {
    text: gt('global.lbl-close'),
    handler: handleCloseDialog
  });

  return /*#__PURE__*/React.createElement(ModalDialog, {
    id: 'trafficEvent',
    title: t('lbl-traffic-related-event'),
    global: true,
    actions: actions,
    closeAction: "cancel"
  }, /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "description"
  }, dialogContent.description), /*#__PURE__*/React.createElement("div", {
    className: "data-info"
  }, t('lbl-type'), ": ", dialogContent.type), /*#__PURE__*/React.createElement("div", {
    className: "data-info"
  }, t('lbl-location'), ": ", dialogContent.location), /*#__PURE__*/React.createElement("div", {
    className: "data-info"
  }, t('lbl-source'), ": ", dialogContent.source), /*#__PURE__*/React.createElement("div", {
    className: "data-info"
  }, t('lbl-released-time'), ": ", dialogContent.beginTime)));
});
export default withTranslation(['traffic-dashboard'])(TrafficEventDialog);